import React, { useEffect, useState } from 'react';
import { supabase } from '../lib/supabaseClient';
import Select from 'react-select';
import Swal from 'sweetalert2';
import imageCompression from 'browser-image-compression';


export default function UploadImageQA() {
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [imageSize, setImageSize] = useState(null);
  const [label, setLabel] = useState('');
  const [outlineOptions, setOutlineOptions] = useState([]);
  const [selectedOutlines, setSelectedOutlines] = useState([]);
  const [questionOptions, setQuestionOptions] = useState([]);
  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const [tag, setTag] = useState('question');
  const [existingImages, setExistingImages] = useState([]);
  const [selectedExistingImage, setSelectedExistingImage] = useState(null);
  const [mode, setMode] = useState('upload');
  const [linkedData, setLinkedData] = useState({ outlines: [], questions: [] });
const [imageWidthOption, setImageWidthOption] = useState(100);  // can be 'custom' or number
const [customWidth, setCustomWidth] = useState(100);
const [selectedWidth, setSelectedWidth] = useState(null);

const [status, setStatus] = useState('');
const [selectedImageUrl, setSelectedImageUrl] = useState(null);

const [uploading, setUploading] = useState(false);
const [deleting, setDeleting] = useState(false);
const [updatingWidth, setUpdatingWidth] = useState(false);
const [processingFile, setProcessingFile] = useState(false);



  useEffect(() => {
    fetchOutlines();
    fetchExistingImages();
  }, []);

  useEffect(() => {
    if (selectedOutlines.length > 0) fetchQuestionsForOutlines();
  }, [selectedOutlines]);

  useEffect(() => {
    if (selectedExistingImage) fetchLinkedData(selectedExistingImage.value);
    else setLinkedData({ outlines: [], questions: [] });
  }, [selectedExistingImage]);

  useEffect(() => {
    const listAllUploads = async () => {
      const { data: fileList, error: listError } = await supabase.storage.from('qa-images').list('uploads');
      if (listError) {
        console.error('Error listing files:', listError.message);
      } else {
        console.log('🗂️ Files in uploads folder:', fileList.map(f => f.name));
      }
    };
  
    listAllUploads();
  }, []);
    // ✅ Add your resetFormState function here
    const resetFormState = () => {
      setImageFile(null);
      setImageSize(null);
      setImagePreview(null);
      setSelectedOutlines([]);
      setSelectedQuestions([]);
      setSelectedExistingImage(null);
      setSelectedImageUrl(null);
      setLabel('');
      setCustomWidth(100);
    };
  const fetchOutlines = async () => {
    const { data, error } = await supabase
      .from('topics')
      .select('id, name, parent:parent_id (module_code)')
      .eq('level', 3);
    if (!error) {
      setOutlineOptions(
        data.map((o) => ({
          value: o.id,
          label: `${o.parent?.module_code || '❓'} - ${o.name}`
        }))
      );
    }
  };

  const fetchExistingImages = async () => {
    const { data, error } = await supabase.from('qa_images').select('*');
    if (!error) setExistingImages(data);
  };

  const fetchQuestionsForOutlines = async () => {
    const outlineIds = selectedOutlines.map((o) => o.value);
    const { data, error } = await supabase
      .from('qa_learning')
      .select('id, order_index, question_blocks')
      .in('outline_id', outlineIds);
    if (!error) {
      const options = data.map((q) => {
        let textBlock = '';
        try {
          const blocks = Array.isArray(q.question_blocks) ? q.question_blocks : JSON.parse(q.question_blocks);
          const firstText = blocks.find((b) => b.type === 'text');
          textBlock = firstText?.value?.slice(0, 40) || 'Untitled';
        } catch {
          textBlock = 'Untitled';
        }
        return {
          value: q.id,
          label: `Q${q.order_index}: ${textBlock}...`
        };
      });
      setQuestionOptions(options);
    }
  };

  const fetchLinkedData = async (imageId) => {
    const { data, error } = await supabase
      .from('qa_image_links')
      .select(`
        question_id,
        tag,
        qa_learning (
          order_index,
          outline_id,
          topics (
            name
          )
        )
      `)
      .eq('image_id', imageId);
  
    if (error) {
      console.error('Error fetching linked questions:', error);
      setLinkedData({ questions: [] });
      return;
    }
  
    const questions = (data || []).map((q) => ({
      question_id: q.question_id,
      tag: q.tag,
      order_index: q.qa_learning?.order_index ?? null,
      outline_id: q.qa_learning?.outline_id ?? null,
      outline_name: q.qa_learning?.topics?.name ?? null
    }));
  
    setLinkedData({ questions });
  };

  
  const handleDeleteSingleLink = async (question_id, outline_id) => {
    const imageId = selectedExistingImage?.value;
    if (!imageId) return;
  
    const confirm = await Swal.fire({
      title: 'Confirm Delete',
      text: 'This will remove the link to this question & outline.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Remove'
    });
  
    if (!confirm.isConfirmed) return;
  
    try {
      await supabase
        .from('qa_image_links')
        .delete()
        .eq('image_id', imageId)
        .eq('question_id', question_id);
  
      await supabase
        .from('qa_image_outline_links')
        .delete()
        .eq('image_id', imageId)
        .eq('outline_id', outline_id);
  
      Swal.fire('Success', 'Link removed.', 'success');
      fetchLinkedData(imageId);
    } catch (err) {
      console.error('Error deleting single link:', err);
      Swal.fire('Error', 'Failed to remove link.', 'error');
    }
  };
  
  
  

  const handleDeleteMapping = async (imageId) => {
    if (!selectedQuestions.length) {
      Swal.fire('Error', 'Please select a question to delete mapping from.', 'error');
      return;
    }

    const questionIds = selectedQuestions.map((q) => q.value);
    const { error } = await supabase
      .from('qa_image_links')
      .delete()
      .in('question_id', questionIds)
      .eq('image_id', imageId);

    if (error) {
      Swal.fire('Error', 'Failed to delete image mapping.', 'error');
    } else {
      Swal.fire('Success', 'Image mapping deleted.', 'success');
      fetchLinkedData(imageId);
    }
  };

 // ✅ INSIDE UploadImageQA component:
const handleDeleteImage = async () => {
  if (!selectedExistingImage) return;

  const confirm = await Swal.fire({
    title: 'Are you sure?',
    text: 'This will delete the image and all its links.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, delete it'
  });
  if (!confirm.isConfirmed) return;
  setDeleting(true); // 🔄 Start spinner
  
  const imageId = selectedExistingImage.value;
  const imageMeta = existingImages.find((img) => img.id === imageId);
  const fileName = imageMeta.image_url.split('/').pop();
  const filePath = `uploads/${decodeURIComponent(fileName)}`;




  console.log('Trying to delete:', filePath);

  try {
    const imageId = selectedExistingImage.value;
    const imageMeta = existingImages.find((img) => img.id === imageId);
    const fileName = imageMeta.image_url.split('/').pop();
    const filePath = `uploads/${decodeURIComponent(fileName)}`;

    await supabase.storage.from('qa-images').remove([filePath]);
    await supabase.from('qa_image_links').delete().eq('image_id', imageId);
    await supabase.from('qa_image_outline_links').delete().eq('image_id', imageId);
    await supabase.from('qa_images').delete().eq('id', imageId);

    Swal.fire('Deleted', 'Image and its links have been deleted.', 'success');
    resetFormState();
    fetchExistingImages();
  } catch (err) {
    console.error('Error deleting:', err);
    Swal.fire('Error', 'Failed to delete image or its links.', 'error');
  } finally {
    setDeleting(false); // ✅ Stop spinner
  }
};


  
  const handleUpload = async () => {



    if (mode === 'upload' && !imageFile) {
      setUploading(false);
      Swal.fire('Error', 'Please choose an image to upload.', 'error');
      return;
    }
    if (selectedOutlines.length === 0) {
      setUploading(false);
      Swal.fire('Error', 'Please select at least one outline.', 'error');
      return;
    }
    if (!label.trim()) {
      Swal.fire('Error', 'Please input label.', 'error');
      setUploading(false);
      setStatus('❌ Please enter an image label before uploading.');
      return;
    }

    setUploading(true);





    try {

      let imageUrl = '';
      let imageId = null;
      if (mode === 'upload') {
        const filename = `${Date.now()}_${imageFile.name}`;
        const fullPath = `uploads/${filename}`;
        console.log('Uploading file size:', imageFile?.size / 1024, 'KB');
        const { error: uploadError } = await supabase.storage.from('qa-images').upload(fullPath, imageFile);
        if (uploadError) throw new Error(uploadError.message);

        const { data: publicUrlData } = supabase.storage.from('qa-images').getPublicUrl(fullPath);
        imageUrl = publicUrlData.publicUrl;
        const selectedWidth = imageWidthOption === 'custom' ? customWidth : imageWidthOption;

        const { data: imageInsert, error: insertError } = await supabase
            .from('qa_images')
            .insert([{ image_url: imageUrl, label, width_percent: selectedWidth }])
            .select();
        if (insertError || !imageInsert || imageInsert.length === 0) throw new Error('Metadata insert failed');
        imageId = imageInsert[0].id;
      } else if (selectedExistingImage) {
        imageId = selectedExistingImage.value;
      }

      const outlineLinks = selectedOutlines.map((o) => ({ image_id: imageId, outline_id: o.value }));
      await supabase.from('qa_image_outline_links').insert(outlineLinks);

      if (selectedQuestions.length > 0) {
        const questionLinks = selectedQuestions.map((q) => ({
          image_id: imageId,
          question_id: q.value,
          tag
        }));
        await supabase.from('qa_image_links').insert(questionLinks);
      }
      setUploading(false);
      Swal.fire('Success', 'Image linked successfully!', 'success');
      setImageFile(null);
      setImageSize(null);
      setImagePreview(null);
      setSelectedOutlines([]);
      setSelectedQuestions([]);
      setSelectedExistingImage(null);
      setLabel('');
      fetchExistingImages();
      resetFormState();
    } catch (err) {
      console.error('Upload Error:', err);
      Swal.fire('Error', err.message || 'Upload failed', 'error');
    }
  };

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setProcessingFile(true); // START spinner

  
    const fileExtension = file.name.split('.').pop().toLowerCase();
    const isGif = fileExtension === 'gif';
  
    const originalSizeKB = (file.size / 1024).toFixed(2);
  
    if (isGif) {
      // Skip compression for GIF
      setImageFile(file);
      setImageSize(`${originalSizeKB} KB (GIF - no compression applied)`);
      Swal.fire('🎞️ GIF detected', 'Animated GIF will be uploaded as is.', 'info');
      setImagePreview(URL.createObjectURL(file));
      setProcessingFile(false); // STOP spinner
      return;
    }
  
    try {
      const options = {
        maxSizeMB: 0.2,
        maxWidthOrHeight: 1024,
        useWebWorker: true,
      };
  
      const compressedFile = await imageCompression(file, options);
      const compressedSizeKB = (compressedFile.size / 1024).toFixed(2);
  
      if (compressedFile.size < file.size) {
        setImageFile(compressedFile);
        setImageSize(`${compressedSizeKB} KB (reduced from ${originalSizeKB} KB)`);
        setProcessingFile(false); // STOP spinner
        Swal.fire('✅ Compressed', `Image reduced from ${originalSizeKB} KB to ${compressedSizeKB} KB`, 'success');
      } else {
        setImageFile(file);
        setImageSize(`${originalSizeKB} KB (no reduction)`);
        setProcessingFile(false); // STOP spinner
        Swal.fire('ℹ️ No Compression Needed', `Original size ${originalSizeKB} KB`, 'info');
      }
  
      setImagePreview(URL.createObjectURL(compressedFile));
    } catch (error) {
      console.error('Compression Error:', error);
      setProcessingFile(false); // STOP spinner
      Swal.fire('Error', 'Image compression failed', 'error');
    }
  };  
  

  const handleUpdateWidth = async () => {
    if (!selectedExistingImage) {
      Swal.fire('Error', 'Please select an image to update.', 'error');
      return;
    }
  
    const widthToUpdate = selectedWidth === 'custom' ? parseInt(customWidth) : selectedWidth;
  
    if (!widthToUpdate || isNaN(widthToUpdate) || widthToUpdate <= 0 || widthToUpdate > 100) {
      Swal.fire('Error', 'Please enter a valid width between 1 and 100.', 'error');
      return;
    }
  
    const { error } = await supabase
      .from('qa_images')
      .update({ width_percent: widthToUpdate })
      .eq('id', selectedExistingImage.value);
  
    if (error) {
      Swal.fire('Error', 'Failed to update width.', 'error');
    } else {
      Swal.fire('Success', `Image width updated to ${widthToUpdate}%`, 'success');
      fetchExistingImages(); // refresh image data
    }
  };
  

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h2 className="text-2xl font-bold mb-4">📸 Upload or Link Image to Q&A</h2>

      <div className="mb-4">
        <label className="block font-medium">Mode:</label>
        <Select
          options={[
            { label: 'Upload New Image', value: 'upload' },
            { label: 'Use Existing Image', value: 'existing' }
          ]}
          value={{ label: mode === 'upload' ? 'Upload New Image' : 'Use Existing Image', value: mode }}
          onChange={(opt) => setMode(opt.value)}
        />
      </div>

      <div className="mb-4">
            <label className="block font-medium">Display Size:</label>
            <Select
                options={[
                { label: 'Full Width (100%)', value: 100 },
                { label: 'Half Width (50%)', value: 50 },
                { label: 'Third Width (33%)', value: 33 },
                { label: 'Custom', value: 'custom' }
                ]}
                value={{
                label: imageWidthOption === 'custom' ? `Custom (${customWidth}%)` : `Width: ${imageWidthOption}%`,
                value: imageWidthOption
                }}
                onChange={(opt) => setImageWidthOption(opt.value)}
            />

            {imageWidthOption === 'custom' && (
                <input
                type="number"
                min={10}
                max={100}
                value={customWidth}
                onChange={(e) => setCustomWidth(Number(e.target.value))}
                className="mt-2 w-full border px-3 py-2 rounded"
                placeholder="Enter custom width % (10–100)"
                />
            )}
            </div>





      {mode === 'upload' ? (
        <div className="mb-4">
          <label className="block font-medium">Select Image:</label>
          <input type="file" accept="image/*" onChange={handleImageChange} />
          {processingFile && (
              <div className="flex items-center text-sm text-indigo-600 mt-2">
                <span className="animate-spin inline-block w-4 h-4 border-2 border-indigo-600 border-t-transparent rounded-full mr-2"></span>
                Processing image...
              </div>
            )}  
          {imageSize && <p className="text-sm text-gray-500 mt-1">Size: {imageSize}</p>}
          {imagePreview && <img src={imagePreview} alt="Preview" className="max-w-xs mt-2 rounded shadow" />}
        </div>
      ) : (
        <div className="mb-4">
          <label className="block font-medium">Select Existing Image:</label>
          <Select
            options={existingImages.map((img) => ({
              value: img.id,
              label: `${img.label || 'Untitled'} (${img.image_url.slice(0, 30)}...)`
            }))}
            value={selectedExistingImage}
            onChange={(selected) => {
              setSelectedExistingImage(selected);
            
              const img = existingImages.find((img) => img.id === selected?.value);
              if (img) {
                setSelectedImageUrl(img.image_url);
              } else {
                setSelectedImageUrl(null);
              }
            }}
          />
          {selectedImageUrl && (
              <img
                src={selectedImageUrl}
                alt="Selected Thumbnail"
                className="mt-3 w-48 max-w-full h-auto rounded border shadow"
              />
            )}
          <div className="mt-2">
  <label className="block text-sm font-medium">Update Width:</label>
  <Select
    options={[
      { value: 100, label: 'Full Width (100%)' },
      { value: 66, label: '2/3 Width (66%)' },
      { value: 50, label: 'Half Width (50%)' },
      { value: 33, label: '1/3 Width (33%)' },
      { value: 'custom', label: 'Custom Width (%)' }
    ]}
    value={
      selectedWidth === 'custom'
        ? { value: 'custom', label: 'Custom Width (%)' }
        : { value: selectedWidth, label: `${selectedWidth}% Width` }
    }
    onChange={(opt) => setSelectedWidth(opt.value)}
    className="mb-2"
  />

    {selectedExistingImage && (
        <p className="text-sm text-gray-600 mt-1">
        🔍 Current Width: {
            existingImages.find(img => img.id === selectedExistingImage.value)?.width_percent || 'Not set'
        }%
        </p>
    )}




  {selectedWidth === 'custom' && (
    <input
      type="number"
      placeholder="Enter custom % width"
      className="w-40 px-2 py-1 border rounded text-sm"
      value={customWidth}
      onChange={(e) => setCustomWidth(e.target.value)}
    />
  )}

  <button
    className="mt-2 px-4 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
    onClick={handleUpdateWidth}
  >
    🔄 Update Image Width
  </button>
</div>
        </div>
      )}

{selectedExistingImage && (
  <div className="mb-4 bg-gray-50 p-3 rounded border text-sm">
    <p className="font-semibold mb-2">🔗 Linked Questions & Outlines:</p>
    <ul className="space-y-2">
        {linkedData.questions.map((q, i) => (
            <li
            key={i}
            className="flex items-center justify-between bg-white border rounded p-2 shadow-sm"
            >
            <div>
                <span className="font-semibold">{q.tag?.toUpperCase() || 'TAG'}:</span>{' '}
                Q{q.order_index ?? q.question_id}{' '}
                <span className="text-gray-500">({q.outline_name || 'Unknown Outline'})</span>
            </div>
            <button
                onClick={() => handleDeleteSingleLink(q.question_id, q.outline_id)}
                className="text-sm px-3 py-1 bg-red-100 hover:bg-red-200 text-red-800 rounded"
            >
                🧹 Remove This Link
            </button>
            </li>
        ))}
        </ul>


        <button
          className="mt-4 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 disabled:opacity-60 flex items-center"
          onClick={handleDeleteImage}
          disabled={deleting}
        >
          {deleting ? (
            <>
              <span className="animate-spin inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full mr-2"></span>
              Deleting...
            </>
          ) : (
            <>
              🗑️ Delete Selected Image
            </>
          )}
        </button>
  </div>
)}



      <div className="mb-4">
        <label className="block font-medium">Image Label (optional):</label>
        <input
          type="text"
          className="w-full border px-3 py-2 rounded"
          value={label}
          onChange={(e) => setLabel(e.target.value)}
        />
      </div>







      <div className="mb-4">
        <label className="block font-medium">Select Outline(s):</label>
        <Select isMulti options={outlineOptions} value={selectedOutlines} onChange={setSelectedOutlines} />
      </div>

      <div className="mb-4">
        <label className="block font-medium">Select Question(s):</label>
        <Select isMulti options={questionOptions} value={selectedQuestions} onChange={setSelectedQuestions} />
      </div>

      <div className="mb-4">
        <label className="block font-medium">Tag as:</label>
        <Select
          options={[{ label: 'Question', value: 'question' }, { label: 'Answer', value: 'answer' }]}
          value={{ label: tag === 'question' ? 'Question' : 'Answer', value: tag }}
          onChange={(opt) => setTag(opt.value)}
        />
      </div>

      <button
        className="px-6 py-2 bg-green-600 text-white rounded hover:bg-green-700 disabled:opacity-60"
        onClick={handleUpload}
        disabled={uploading}
      >
        {uploading ? (
          <>
            <span className="animate-spin inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full"></span>
            Uploading...
          </>
        ) : (
          <>
            <span>🔗</span> Upload / Link Image
          </>
        )}
      </button>

      {selectedQuestions.length > 0 && selectedExistingImage && (
        <button
          className="mt-4 px-6 py-2 bg-red-600 text-white rounded hover:bg-red-700"
          onClick={() => handleDeleteMapping(selectedExistingImage.value)}
        >
          ❌ Remove Selected Mappings
        </button>
      )}
    </div>
  );
}
